import { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, Typography, Divider, CircularProgress, Box } from '@mui/material';
import axios from 'axios';

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    let isMounted = true;
  
    axios
      .get('https://ipms.insollex.com/api/user', { withCredentials: true })
      .then((res) => {
        if (isMounted) {
          setUserId(res.data.id);
          setError('');
        }
      })
      .catch(() => {
        if (isMounted) {
          setError('User not logged in');
          setLoading(false); // ✅ Important!
        }
      });
  
    return () => {
      isMounted = false;
    };
  }, []);

  
  // Fetch notifications when the component mounts
  useEffect(() => {
    if (!userId) return;
  
    const fetchNotifications = async () => {
      try {
        const response = await axios.get('https://ipms.insollex.com/api/notifications', {
          params: { userId },
        });
  
        if (response.data && response.data.notifications) {
          setNotifications(response.data.notifications);
        } else {
          setNotifications([]);
        }
  
      } catch (error) {
        console.error('Error fetching notifications:', error);
        setError('Failed to fetch notifications');
      } finally {
        setLoading(false); // ✅ Ensure this always runs
      }
    };
  
    fetchNotifications();
  }, [userId]);

  if (loading) {
  return (
    <Box sx={{ padding: 4, textAlign: 'center' }}>
      <CircularProgress />
    </Box>
  );
}

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Notifications
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {error ? (
        <Typography variant="body1" color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      ) : notifications.length === 0 ? (
        <Typography variant="body1">No notifications available.</Typography>
      ) : (
        <List>
          {notifications.map((notification) => (
            <ListItem key={notification.id}>
              <ListItemText
                primary={notification.title}
                secondary={notification.description}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
}
